export default __webpack_public_path__ + "static/media/13.fb7acb1a.png";